module.exports = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 12.68V4.32c0-.724-.578-1.313-1.29-1.319L14.702 3H1.297l-.006.001A1.312 1.312 0 0 0 0 4.321v8.359C0 13.408.584 14 1.3 14h13.4c.716 0 1.3-.592 1.3-1.32zM7.71 9.927a.427.427 0 0 0 .58 0l1.841-1.693 4.432 4.886H1.437l4.432-4.886L7.71 9.927zm7.425 2.526l-4.362-4.808 4.065-3.737c.172.06.297.22.297.412v8.133zM13.58 3.88L8 9.007 2.421 3.88h11.158zm-12.417.028l4.065 3.737-4.362 4.808V4.32c0-.193.125-.352.297-.412z\" fill-rule=\"nonzero\"/></svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/mail.svg
// module id = 973
// module chunks = 0